import { connect } from 'react-redux';

const { refeshCustomerActions } = require("src/main_app/actions");

const mapStateToProps = null
const mapActionToProps = {
    refeshCustomerActions
}

const withRedux = component => connect(
    mapStateToProps,
    mapActionToProps
)(component)

export default withRedux
